import {
    UPDATE_ADD_TO_CART, UPDATE_MESSAGE
} from '../middleware/types'

const initialState = {
    SUBMIT_loading: false,
    error: {},
}

export default (state = initialState, action) => {
    switch (action.type) {
        case UPDATE_MESSAGE:
            return {
                ...state,
                SUBMIT_loading: false,
                message: action.message,
            }
        default:
            return state
    }
}